import React, { useContext, useEffect, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'
import DownloadIcon from '@mui/icons-material/Download'
import Button from '@mui/material/Button'

import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'
import BackEndAPI from '../../../Services/BackEndAPI'
import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable'
import ClsExportDataTableCSV from '../../../Utils/ClsExportDataTableCSV'
import { DeviceErroInterface } from '../../../ImportBackend/Interfaces/DeviceInterfaces'

const Cabecalho: Array<DataTableCabecalhoInterface> = [
  {
    campo: 'hostname',
    cabecalho: 'Hostname',
    alinhamento: 'left'
  },
  {
    campo: 'motivo',
    cabecalho: 'Motivo',
    alinhamento: 'left'
  }
]

export default function DevicesLogErros () {

  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface

  const clsApi: BackEndAPI = new BackEndAPI()

  const navigate = useNavigate()

  const [rsDeviceErros, setRsDeviceErros] = useState<Array<DeviceErroInterface>>( [] )

  useEffect( () => {

    const abortController: AbortController = new AbortController()

    const query = `
      getDeviceErros {
        idDeviceErro
        hostname
        motivo
      }
    `

    clsApi.query<Array<DeviceErroInterface>>( query, 'getDeviceErros', 'Pesquisando Log de Erros...', contexto, abortController ).then( rs => {
      setRsDeviceErros( rs )
    } )

    return () => {
      abortController.abort()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] )

  const btExportarCSV = () => {
    ( new ClsExportDataTableCSV() ).exportCSV( 'DeviceErros', rsDeviceErros, Cabecalho )
  }

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Log de Erros de Devices
              </Typography>

              <IconButton onClick={() => navigate( '/' )}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12} sx={{ mb: 2, textAlign: 'right' }}>
              <Button variant='contained' startIcon={<DownloadIcon />} onClick={() => btExportarCSV()}>Exportar CSV</Button>
            </Grid>

            <Grid item xs={12}>
              <DataTable dados={rsDeviceErros} cabecalho={Cabecalho} />
            </Grid>

          </Grid>
        </Paper>

      </Container>
    </>
  )

}
